import { BASE_API_LIVE_SWAP } from 'config/constants/endpoints'
import fetchHelper from 'helpers/FetchHelper'

function getListMyNft(): Promise<MyNFTType[]> {
  return new Promise<any>((resolve, reject) => {
    try {
      fetchHelper
        .fetch(`${BASE_API_LIVE_SWAP}/nft-stake/my-nft`, {
          method: 'GET',
        })
        .then(([resp, status]: any) => {
          if (status === 200) {
            resolve(resp?.data)
          }

          throw resp
        })
    } catch (error) {
      reject(error)
    }
  })
}

export default getListMyNft

export interface MyNFTType {
  _id: string
  updatedAt: Date
  createdBy?: string
  userId: string
  nftId: NftID
  price: number
  remainBonus: number
  bonusTotal: number
  isStaked: boolean
  isCompleted: boolean
  buyTime: string
  createdAt: Date
  id: string
}

export interface NftID {
  _id: string
  title: string
  apr: number
  description: string
  image: string
  isPublic: boolean
  price: number
  thumbnail: string
  id: string
}

export interface StakePlanID {
  _id: string
  quantity: number
  isBoost: boolean
  status: StatusType
  startDate: number
  endDate: number
  id: string
}

type StatusType = 'COMPLETED' | 'RUNNING' | 'UNSTAKED'
